import { CancelButton, GroupButton } from '@core/components/Buttons';
import Carousel from '@core/components/Carousel';
import { CustomExpandedPanel } from '@core/components/CustomExpandedPanel';
import { SimpleDialog, SimpleDialogContent } from '@core/components/Dialog';
import FormTitle from '@core/components/FormTitle';
import { CompetenciaInput, DateInput, TextLabel } from '@core/components/Inputs';
import { ListView } from '@core/components/List';
import { getValueFromOptions } from '@core/components/Select';
import { permissaoUtils } from '@core/util/permissaoUtil';
import { DataBR } from '@format/DATA';
import { Divider, Grid, IconButton, Popover, Tooltip, Typography } from '@material-ui/core';
import { anexoApi } from 'app/services/api/anexoApi';
import contasPagarApi from 'app/services/api/contasPagarApi';
import { fechamentoPeriodoApi } from 'app/services/api/fechamentoPeriodoApi';
import { relatorioApi } from 'app/services/api/relatorioApi';
import { getCurrency } from 'app/utils/monetarioUtil';
import { diferenteDe } from 'app/utils/validation';
import moment from 'moment';
import NP from 'number-precision';
import React, { useEffect, useState } from 'react';
import { FaArrowCircleDown } from 'react-icons/fa';
import { MdSettings } from 'react-icons/md';
import { visualizarRelatorioV2 } from '../../../utils/enviromentUtil';
import { opcoesFormaDePagamento } from '../components/FormaDePagamento';
import { ContasPagarAction, useContasPagar } from '../store';
import { ContasPagarUtil } from '../store/contasPagarAction';
import ContasPagarPagamentosRealizados from './ContasPagarPagamentosRealizados';
import HistoricoContasPagarVisualizacao from '../components/HistoricoContasPagarVisualizacao';

const Retencoes = ({ values }) => {
  const { retencoes, valorBruto, valorLiquido } = values;
  return (
    <Grid item xs={12}>
      <Grid container spacing={3}>
        <ListView
          title="Retenção"
          hideTitle
          hideDivider
          showOnlyFirstLabel
          showMoreTitle="Ver mais retenções"
          values={retencoes}
          style={{ paddingTop: 0 }}
          options={[
            {
              title: 'Imposto',
              name: 'imposto.nome',
              format: (data) => ContasPagarUtil.nomeImpostoFormat(data?.imposto),
              grid: { xs: 12, sm: 4 },
            },
            {
              title: 'Valor (R$)',
              name: 'valor',
              format: (data) => getCurrency(data.valor).replace('R$', ''),
              grid: { xs: 12, sm: 4 },
            },
            {
              title: 'Data do vencimento',
              name: 'dataVencimento',
              format: (data) => DataBR(data?.dataVencimento),
              grid: { xs: 12, sm: 4 },
            },
          ]}
        />
        <Grid item xs={4}>
          <TextLabel
            fullWidth
            id="valorBruto"
            label="Valor total bruto (R$)"
            value={getCurrency(valorBruto).replace('R$', '')}
          />
        </Grid>
        <Grid item xs={4}>
          <TextLabel
            fullWidth
            id="valorLiquido"
            label="Valor total líquido (R$)"
            value={getCurrency(valorLiquido).replace('R$', '')}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

const RetencaoSelecionada = ({ values }) => {
  const { retencoes } = values;
  const [retencaoSelecionada] = retencoes.filter((retencao) => retencao.id === values?.retencaoId);
  const outrasRetencoes = retencoes.filter((retencao) => retencao.id !== values?.retencaoId);

  return (
    <Grid item xs={12}>
      <p />
      <FormTitle title="Retenção selecionada" />
      <Grid container spacing={3}>
        <Grid item xs={4}>
          <TextLabel
            id="imposto"
            label="Imposto"
            value={ContasPagarUtil.nomeImpostoFormat(retencaoSelecionada?.imposto)}
          />
        </Grid>
        <Grid item xs={8}>
          <TextLabel id="valor" label="Valor (R$)" value={getCurrency(retencaoSelecionada?.valor).replace('R$', '')} />
        </Grid>
        <Grid item xs={4}>
          <TextLabel
            id="dataVencimentoRetencao"
            label="Data do vencimento"
            value={DataBR(retencaoSelecionada?.dataVencimento)}
          />
        </Grid>
        <Grid item xs={8}>
          <TextLabel
            id="contribuinte"
            label="Contribuinte"
            value={
              retencaoSelecionada?.contribuinte &&
              getValueFromOptions(
                [
                  { id: 'EMPRESA', title: 'Empresa' },
                  { id: 'FORNECEDOR', title: 'Fornecedor' },
                ],
                retencaoSelecionada?.contribuinte
              ).title
            }
          />
        </Grid>
        <Grid item xs={4}>
          <TextLabel
            id="contaRetencao"
            label="Conta"
            value={ContasPagarUtil.contaBancariaFormat(retencaoSelecionada?.conta)}
          />
        </Grid>
        <Grid item xs={8}>
          <TextLabel
            id="formaPagamentoRetencao"
            label="Forma do pagamento"
            value={
              retencaoSelecionada?.formaPagamento &&
              getValueFromOptions(opcoesFormaDePagamento, retencaoSelecionada?.formaPagamento).title
            }
          />
        </Grid>
        <Grid item xs={12}>
          <TextLabel id="codigoBarras" label="Código de barras" value={retencaoSelecionada?.linhaDigitavel} />
        </Grid>
      </Grid>
      {outrasRetencoes.length > 0 && (
        <>
          <p style={{ paddingTop: 20 }} />
          <FormTitle title="Outras retenções" />
          <Grid container spacing={3}>
            <ListView
              title="Retenção"
              hideTitle
              hideDivider
              showOnlyFirstLabel
              showMoreTitle="Ver mais retenções"
              values={outrasRetencoes}
              style={{ paddingTop: 0 }}
              options={[
                {
                  title: 'Imposto',
                  name: 'imposto.nome',
                  format: (data) => data?.imposto?.nome,
                  grid: { xs: 12, sm: 4 },
                },
                { title: 'Valor', name: 'valor', format: (data) => getCurrency(data.valor), grid: { xs: 12, sm: 4 } },
                {
                  title: 'Data do vencimento',
                  name: 'dataVencimento',
                  format: (data) => DataBR(data?.dataVencimento),
                  grid: { xs: 12, sm: 4 },
                },
              ]}
            />
          </Grid>
        </>
      )}
    </Grid>
  );
};

const DadosRetencoes = ({ values }) => {
  if (values?.retencaoId) {
    return <RetencaoSelecionada values={values} />;
  }

  return <Retencoes values={values} />;
};

const ContasPagarCategoriasVisualizar = ({ values }) => {
  const { categorias } = values;

  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElIndex, setAnchorElIndex] = useState(null);

  const handleClick = (event, index) => {
    setAnchorElIndex(index);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorElIndex(null);
    setAnchorEl(null);
  };

  const PopoverHeader = () => (
    <>
      <Grid
        container
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingTop: 20,
          paddingBottom: 20,
          paddingLeft: 20,
        }}
      >
        <Grid item md={8} sm={8} xs={8}>
          <Typography
            style={{
              fontWeight: 'bold',
              color: 'rgb(35,61,77)',
              fontSize: 16,
            }}
          >
            Rateio dos centros de custos
          </Typography>
        </Grid>
        <Grid item md={4} sm={4} xs={4} style={{ display: 'flex', justifyContent: 'center' }}>
          <CancelButton title="fechar" type="button" onClick={handleClose}>
            Fechar
          </CancelButton>
        </Grid>
      </Grid>
      <Grid
        container
        style={{
          paddingTop: 15,
          paddingLeft: 20,
        }}
      >
        <Grid item md={6} sm={6} xs={6}>
          <Typography
            style={{
              fontWeight: 'bold',
            }}
          >
            Centro de custo
          </Typography>
        </Grid>
        <Grid item md={6} sm={6} xs={6}>
          <Typography
            style={{
              fontWeight: 'bold',
            }}
          >
            Percentual (%)
          </Typography>
        </Grid>
      </Grid>
    </>
  );

  const PopoverContent = ({ rateios }) => (
    <>
      {rateios?.map((rateio) => (
        <Grid container key={rateio.id} style={{ paddingLeft: 20 }}>
          <Grid container>
            <Grid item md={6} sm={6} xs={6}>
              <Grid style={{ marginTop: 5 }}>
                <Typography>
                  {rateio.classe.indice} {rateio.classe.nome}
                </Typography>
              </Grid>
            </Grid>
            <Grid item md={6} sm={6} xs={6}>
              <Grid style={{ marginTop: 5 }}>
                <Typography>{rateio.percentual}</Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      ))}
    </>
  );

  return (
    <Grid item xs={12}>
      <Grid container spacing={3}>
        {categorias.map((categoria, index) => (
          <ListView
            key={index}
            title="Categoria"
            hideTitle
            hideDivider
            showOnlyFirstLabel
            showMoreTitle="Ver mais categorias"
            values={[categoria]}
            style={{ paddingTop: 0 }}
            options={[
              {
                title: 'Categoria',
                name: 'classe.nome',
                format: (data) => {
                  return `${data.classe.indice}  ${data.classe.nome}`;
                },
                grid: { xs: 12, sm: 4 },
              },
              {
                title: 'Valor bruto (R$)',
                name: 'valorBruto',
                format: (data) => getCurrency(data.valorBruto).replace('R$', ''),
                grid: { xs: 12, sm: 3 },
              },
              { title: 'Descrição', name: 'descricao', grid: { xs: 12, sm: 3 } },
              {
                title: '',
                name: 'rateios',
                format: () => (
                  <>
                    <Tooltip title="Rateio dos centros de custos" placement="right-end">
                      <IconButton onClick={(event) => handleClick(event, index)}>
                        <MdSettings size={20} style={{ color: 'rgb(35,61,77)' }} />
                      </IconButton>
                    </Tooltip>
                    <Popover
                      open={index === anchorElIndex}
                      anchorEl={anchorEl}
                      onClose={handleClose}
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                      }}
                      PaperProps={{
                        style: { width: 400 },
                      }}
                    >
                      <PopoverHeader />
                      <PopoverContent rateios={categoria.rateios} />

                      <Grid style={{ paddingBottom: 20 }} />
                    </Popover>
                  </>
                ),
                grid: { xs: 12, sm: 2 },
              },
            ]}
          />
        ))}
      </Grid>
    </Grid>
  );
};

const ContasPagarParcelasVisualizar = ({ values }) => {
  return (
    <>
      <FormTitle title={`Conta selecionada - Parcela ${values?.parcela}/${values?.numeroParcelas}`} />
      <Grid container spacing={3}>
        <Grid item xs={4}>
          <TextLabel id="dataVencimento" label="Data do vencimento" value={DataBR(values?.dataVencimento)} />
        </Grid>
        <Grid item xs={8}>
          <TextLabel
            id="valorLiquidoParcela"
            label="Valor parcelado líquido (R$)"
            value={getCurrency(values?.valorLiquido).replace('R$', '')}
          />
        </Grid>
        <Grid item xs={4}>
          <TextLabel id="conta" label="Conta" value={ContasPagarUtil.contaBancariaFormat(values?.conta)} />
        </Grid>
        <Grid item xs={8}>
          <TextLabel
            id="formaPagamento"
            label="Forma do pagamento"
            value={values?.formaPagamento && getValueFromOptions(opcoesFormaDePagamento, values?.formaPagamento).title}
          />
        </Grid>
        <Grid item xs={12}>
          <TextLabel id="codigoBarras" label="Código de barras" value={values?.linhaDigitavel} />
        </Grid>
      </Grid>
      <Divider style={{ backgroundColor: 'rgba(0, 0, 0, 0.50)', marginBottom: 8 }} />
    </>
  );
};

const DadosDespesaParcelada = ({ values }) => {
  const _parcela = {
    ...(values?.parcelamento?.parcelas || [{}])[values?.parcela - 1],
    numeroParcelas: values?.numeroParcelas,
    parcela: values?.parcela,
  };

  return (
    <>
      <Grid item xs={12} sm={4}>
        <CompetenciaInput
          readOnly
          required
          fullWidth
          id="competencia"
          label="Mês competência"
          value={values.competencia}
          format="MM/YYYY"
        />
      </Grid>
      <Grid item xs={12} sm={8}>
        {values.origemLancamento && diferenteDe('CONTA_PAGAR', values.origemLancamento) && (
          <TextLabel
            id="origemLancamento"
            label="Origem do lançamento"
            value={
              getValueFromOptions(
                [
                  { id: 'CONTA_PAGAR', title: 'Contas a Pagar' },
                  { id: 'COMPRA_PRODUTO', title: 'Compra' },
                  { id: 'COMPRA_SERVICO', title: 'Compra' },
                  { id: 'COMPRA', title: 'Compra' },
                ],
                values.origemLancamento
              ).title
            }
          />
        )}
      </Grid>

      <Grid item xs={12} sm={4}>
        <TextLabel id="valorTotal" label="Valor total (R$)" value={getCurrency(values?.valorBruto).replace('R$', '')} />
      </Grid>

      <Grid item xs={12} sm={8}>
        <TextLabel id="numeroParcelas" label="Número de parcelas" value={values?.parcelamento?.parcelas?.length || 0} />
      </Grid>

      {!values?.retencaoId && (
        <Grid item xs={12}>
          <ContasPagarParcelasVisualizar values={_parcela} />
        </Grid>
      )}

      <Grid item xs={12} sm={12}>
        <TextLabel id="fornecedor" label="Fornecedor" fullWidth value={values?.fornecedor?.pessoa?.nome} />
      </Grid>
      {values?.favorecidoDiferenteFornecedor && (
        <Grid item xs={12} sm={12}>
          <TextLabel id="favorecido" label="Favorecido" fullWidth value={values?.favorecido?.pessoa?.nome} />
        </Grid>
      )}

      <ContasPagarCategoriasVisualizar values={values} />

      <Grid item xs={12} sm={4}>
        <TextLabel id="documentoFiscal" label="Documento fiscal" fullWidth value={values?.documentoFiscal} />
      </Grid>

      <Grid item xs={12} sm={4}>
        <DateInput fullWidth readOnly id="dataEmissao" label="Data da emissão" value={values?.dataEmissao} />
      </Grid>

      <Grid item xs={12}>
        <TextLabel id="observacao" label="Observação" value={values?.observacao} />
      </Grid>
    </>
  );
};

const DadosDespesaCodigoBarras = ({ values }) => {
  return (
    <>
      <Grid item xs={12}>
        <TextLabel
          id="linhaDigitavel"
          name="linhaDigitavel"
          value={values?.linhaDigitavel}
          fullWidth
          label="Código de barras"
        />
      </Grid>

      <Grid item xs={12} sm={12}>
        <TextLabel id="fornecedor" label="Fornecedor" fullWidth value={values?.fornecedor?.pessoa?.nome} />
      </Grid>
      {values?.favorecido && (
        <Grid item xs={12} sm={12}>
          <TextLabel id="favorecido" label="Favorecido" fullWidth value={values?.favorecido?.pessoa?.nome} />
        </Grid>
      )}
      <Grid item xs={12} sm={4}>
        <DateInput
          readOnly
          required
          fullWidth
          id="competencia"
          label="Mês competência"
          value={values.competencia}
          dateFormat="MM/YYYY"
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <DateInput readOnly fullWidth id="dataVencimento" label="Data do vencimento" value={values.dataVencimento} />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextLabel id="valorTotal" label="Valor total (R$)" fullWidth value={values?.valorBruto} />
      </Grid>

      <ContasPagarCategoriasVisualizar values={values} />

      <Grid item xs={12} sm={4}>
        <TextLabel id="conta" fullWidth label="Conta" value={ContasPagarUtil.contaBancariaFormat(values?.conta)} />
      </Grid>

      <Grid item xs={12} sm={8}>
        <TextLabel
          id="formaPagamento"
          label="Forma do pagamento"
          value={values?.formaPagamento && getValueFromOptions(opcoesFormaDePagamento, values?.formaPagamento).title}
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <TextLabel id="documentoFiscal" label="Documento fiscal" fullWidth value={values?.documentoFiscal} />
      </Grid>

      <Grid item xs={12} sm={8}>
        <DateInput readOnly fullWidth id="dataEmissao" label="Data da emissão" value={values.dataEmissao} />
      </Grid>

      <Grid item xs={12}>
        <TextLabel id="observacao" label="Observação" value={values?.observacao} />
      </Grid>
    </>
  );
};

const DadosDespesaUnica = ({ values }) => {
  return (
    <>
      <Grid item xs={12} sm={4}>
        <DateInput
          readOnly
          format="MM/YYYY"
          fullWidth
          id="competencia"
          label="Mês competência"
          value={values.competencia}
        />
      </Grid>
      <Grid item xs={12} sm={8}>
        {values.origemLancamento && diferenteDe('CONTA_PAGAR', values.origemLancamento) && (
          <TextLabel
            id="origemLancamento"
            label="Origem do lançamento"
            value={
              getValueFromOptions(
                [
                  { id: 'CONTA_PAGAR', title: 'Contas a Pagar' },
                  { id: 'COMPRA_PRODUTO', title: 'Compra' },
                  { id: 'COMPRA_SERVICO', title: 'Compra' },
                  { id: 'COMPRA', title: 'Compra' },
                  { id: 'CONTRATO_PB', title: 'Partner Bank' },
                  { id: 'VENDA_PB', title: 'Partner Bank' },
                  { id: 'CONCILIACAO', title: 'Conciliação bancária' },
                ],
                values.origemLancamento
              ).title
            }
          />
        )}
      </Grid>

      <Grid item xs={12} sm={12}>
        <TextLabel id="fornecedor" label="Fornecedor" fullWidth value={values.fornecedor.pessoa.nome} />
      </Grid>
      {values?.favorecidoDiferenteFornecedor && (
        <Grid item xs={12} sm={12}>
          <TextLabel id="favorecido" label="Favorecido" fullWidth value={values.favorecido?.pessoa?.nome} />
        </Grid>
      )}
      <ContasPagarCategoriasVisualizar values={values} />

      <Grid item xs={12} sm={4}>
        <DateInput readOnly fullWidth id="dataVencimento" label="Data do vencimento" value={values.dataVencimento} />
      </Grid>

      <Grid item xs={12} sm={4}>
        <TextLabel
          id="conta"
          fullWidth
          label="Conta"
          value={ContasPagarUtil.contaBancariaFormat(values?.baixa?.conta || values?.conta)}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextLabel
          id="formaPagamento"
          label="Forma do pagamento"
          value={
            (values?.baixa?.formaPagamento || values?.formaPagamento) &&
            getValueFromOptions(opcoesFormaDePagamento, values?.baixa?.formaPagamento || values?.formaPagamento).title
          }
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <TextLabel id="documentoFiscal" label="Documento fiscal" fullWidth value={values.documentoFiscal} />
      </Grid>

      <Grid item xs={12} sm={8}>
        <DateInput readOnly fullWidth id="dataEmissao" label="Data da emissão" value={values.dataEmissao} />
      </Grid>

      <Grid item xs={12}>
        <TextLabel
          id="linhaDigitavel"
          name="linhaDigitavel"
          value={values?.linhaDigitavel}
          fullWidth
          variant="outlined"
          label="Código de barras"
        />
      </Grid>

      <Grid item xs={12}>
        <TextLabel id="observacao" label="Observação" value={values?.observacao} />
      </Grid>
    </>
  );
};

const DadosDespesa = ({ values }) => {
  if (values?.tipoDespesa === 'UNICA') {
    return <DadosDespesaUnica values={values} />;
  }
  if (values?.tipoDespesa === 'PARCELADA' || values?.tipoDespesa === 'PARCELA') {
    return <DadosDespesaParcelada values={values} />;
  }
  if (values?.tipoDespesa === 'LINHA_DIGITAVEL') {
    return <DadosDespesaCodigoBarras values={values} />;
  }
  return <>Não encontrado</>;
};

const AnexosDocumentos = ({ values }) => {
  const urlAnexoContasPagarApi = contasPagarApi.getAnexoUrlDownload();

  const download = async (anexo) => {
    const response = await anexoApi().downloadAnexo(`${urlAnexoContasPagarApi}/${anexo.id}`);
    const contentType = response.headers['content-type'];
    const url = window.URL.createObjectURL(new Blob([response.data], { type: contentType }));
    const link = document.createElement('a');

    link.href = url;
    link.setAttribute('download', anexo.nome);
    document.body.appendChild(link);
    link.click();
  };

  const imagens = values?.anexos?.filter(
    (file) => file.contentType === 'image/jpeg' || file.contentType === 'image/png'
  );

  const documentos = values?.anexos?.filter(
    (file) => file.contentType !== 'image/jpeg' && file.contentType !== 'image/png'
  );

  return (
    <Grid container>
      <Grid item xs={12}>
        <Carousel images={imagens} allowDownload urlAnexoApi={urlAnexoContasPagarApi} />
      </Grid>

      {documentos?.map((anexo) => (
        <Grid item xs={12}>
          <p className="mb-4">
            <button type="submit" style={{ color: '#53c4e6', fontSize: 15 }} onClick={() => download(anexo)}>
              {anexo?.nome}
            </button>
          </p>
        </Grid>
      ))}
    </Grid>
  );
};

const BaixaDaConta = ({ values }) => {
  // Ordenar os valores por data de pagamento, para pegar o mais recente
  const sortedValues = values.sort((a, b) => new Date(b.dataPagamento) - new Date(a.dataPagamento));

  // Última data de pagamento, origem da baixa e número do cheque
  const lastDataPagamento = sortedValues[0].dataPagamento;
  const lastDataLiquidacao = sortedValues[0].dataLiquidacao;
  const lastOrigemBaixa = sortedValues[0].origemBaixa;
  const lastNumeroCheque = sortedValues.find((item) => item.numeroCheque)?.numeroCheque;

  // Somar juros, multas, descontos e valores pagos
  const totalJuros = sortedValues.reduce((sum, item) => sum + (item.juros?.valor || 0), 0);
  const totalMulta = sortedValues.reduce((sum, item) => sum + (item.multa?.valor || 0), 0);
  const totalDesconto = sortedValues.reduce((sum, item) => sum + (item.desconto?.valor || 0), 0);
  const totalValorPago = sortedValues.reduce((sum, item) => sum + item.valorPago, 0);

  return (
    <>
      <Grid item xs={12} sm={4}>
        <DateInput readOnly required fullWidth id="dataPagamento" label="Data do pagamento" value={lastDataPagamento} />
      </Grid>
      <Grid item xs={12} sm={4}>
        <DateInput
          readOnly
          required
          fullWidth
          id="dataLiquidacao"
          label="Data da liquidação"
          value={lastDataLiquidacao}
        />
      </Grid>
      <Grid item xs={12} sm={4} margin-left="25px">
        {lastOrigemBaixa && diferenteDe('CONTA_PAGAR', lastOrigemBaixa) && (
          <TextLabel
            id="origemBaixa"
            label="Origem da baixa"
            value={
              lastOrigemBaixa &&
              getValueFromOptions(
                [
                  { id: 'CONTA_PAGAR', title: 'Contas a Pagar' },
                  { id: 'COMPRA_PRODUTO', title: 'Compra' },
                  { id: 'COMPRA_SERVICO', title: 'Compra' },
                  { id: 'COMPRA', title: 'Compra' },
                  { id: 'CONTRATO_PB', title: 'Partner Bank' },
                  { id: 'VENDA_PB', title: 'Partner Bank' },
                  { id: 'CONCILIACAO', title: 'Conciliação bancária' },
                ],
                lastOrigemBaixa
              ).title
            }
          />
        )}
      </Grid>
      <Grid item xs={12} sm={4}>
        {lastNumeroCheque && <TextLabel id="numeroCheque" label="Número do cheque" value={lastNumeroCheque} />}
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextLabel id="juros" label="Juros (R$)" value={getCurrency(totalJuros).replace('R$', '')} />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextLabel id="multa" label="Multa (R$)" value={getCurrency(totalMulta).replace('R$', '')} />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextLabel id="desconto" label="Desconto (R$)" value={getCurrency(totalDesconto).replace('R$', '')} />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextLabel id="valorPago" label="Valor pago (R$)" value={getCurrency(totalValorPago).replace('R$', '')} />
      </Grid>
    </>
  );
};

const AproveitamentoCredito = ({ values, valorTotalCategorias = 0 }) => {
  const PARCIAL = values?.tipoAproveitamentoCredito === 'CREDITO_PARCIAL';
  const INTEGRAL = values?.tipoAproveitamentoCredito === 'CREDITO_INTEGRAL';

  const aliquotaCbs = NP.divide(Number(values?.aliquotaCbs) || 0, 100);
  const aliquotaIbs = NP.divide(Number(values?.aliquotaIbs) || 0, 100);

  const creditoIbs = Number(values?.valorCreditoIbs) || 0;
  const creditoCbs = Number(values?.valorCreditoCbs) || 0;

  const valorBaseCbs = NP.times(valorTotalCategorias, aliquotaCbs);
  const valorBaseIbs = NP.times(valorTotalCategorias, aliquotaIbs);

  const percentual = NP.divide(Number(values?.percentualCredito) || 0, 100);

  const valorParcialCbs = NP.times(valorBaseCbs, percentual);
  const valorParcialIbs = NP.times(valorBaseIbs, percentual);

  const temCreditoLancado = !!values?.valorCreditoIbs || !!values?.valorCreditoCbs;
  const creditoTotal = temCreditoLancado ? creditoIbs + creditoCbs : '-';

  const formatTipoAproveitamento = (tipo) => {
    switch (tipo) {
      case 'CREDITO_PARCIAL':
        return 'Crédito parcial';
      case 'CREDITO_INTEGRAL':
        return 'Crédito integral';
      case 'NAO_APROVEITA_CREDITO':
        return 'Não aproveita crédito';
      default:
        return '-';
    }
  };

  return (
    <>
      <Grid container spacing={3} className="mb-8">
        <Grid item xs={12} sm={4}>
          <TextLabel
            id="tipoAproveitamentoCredito"
            label="Aproveitamento de crédito"
            value={formatTipoAproveitamento(values?.tipoAproveitamentoCredito)}
          />
        </Grid>

        {PARCIAL && (
          <>
            <Grid item xs={12} sm={4} md={4}>
              <TextLabel
                id="percentualCredito"
                label="Percentual de crédito (%)"
                value={values?.percentualCredito ? values?.percentualCredito : '-'}
              />
            </Grid>
            <Grid item xs={12} sm={2} md={2}>
              <TextLabel id="aliquotaIbs" label="Alíquota IBS %" value={values?.aliquotaIbs || '-'} />
            </Grid>
            <Grid item xs={12} sm={2} md={2}>
              <TextLabel id="aliquotaCbs" label="Alíquota CBS %" value={values?.aliquotaCbs || '-'} />
            </Grid>
            <Grid item xs={12} sm={12} style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <Grid>
                <span>{`Valores base: IBS = R$ ${getCurrency(valorBaseIbs)} | CBS = R$ ${getCurrency(
                  valorBaseCbs
                )}`}</span>
              </Grid>
              <Grid>
                <span>
                  {`Valores parcial: IBS = R$ ${getCurrency(valorParcialIbs)} | CBS = R$ ${getCurrency(
                    valorParcialCbs
                  )}`}
                </span>
              </Grid>
            </Grid>
          </>
        )}
        {INTEGRAL && (
          <>
            <Grid item xs={12} sm={12} md={12} style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <Grid item>
                <TextLabel id="labelValoresCalculados" label="Valores de crédito calculados:" value={' '} />
              </Grid>

              <Grid item xs={12} style={{ display: 'flex' }}>
                <Grid item xs={12} sm={4} md={4}>
                  <TextLabel id="valorCreditoIbs" label="Crédito IBS (R$)" value={getCurrency(creditoIbs)} />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <TextLabel id="valorCreditoCbs" label="Crédito CBS (R$)" value={getCurrency(creditoCbs)} />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <TextLabel id="valorCreditoTotal" label="Crédito total (R$)" value={getCurrency(creditoTotal)} />
                </Grid>
              </Grid>
            </Grid>
          </>
        )}
      </Grid>
    </>
  );
};

const FormVisualizar = ({ registro }) => {
  const [expanded, setExpanded] = useState(registro?.retencaoId ? 'retencao' : 'dadosDespesa');

  const [expanded2, setExpanded2] = useState('');

  const [, setBaixaEmParcelas] = useState(false);

  useEffect(() => {
    verificarBaixaEmParcelas();
    // Efeito de montagem: roda uma única vez. Incluir as dependências reexecutaria a carga
    // inicial a cada render (loop de chamadas à API).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const verificarBaixaEmParcelas = () => {
    if (registro?.baixas?.length > 0) {
      setBaixaEmParcelas(true);
    } else if (registro?.parcelamento?.parcelas?.length > 0) {
      for (var i = 0; i < registro?.parcelamento?.parcelas?.length; i++) {
        if (registro?.parcelamento?.parcelas[i]?.baixas?.length > 0) {
          setBaixaEmParcelas(true);
          break;
        }
      }
    }
  };

  const handleExpandedChange = (key, value) => {
    if (value) {
      setExpanded2(key);
    } else {
      setExpanded2(false);
    }
  };

  const _parcela = {
    ...(registro?.parcelamento?.parcelas || [{}])[registro?.parcela - 1],
    numeroParcelas: registro?.numeroParcelas,
    parcela: registro?.parcela,
    parcelamentoDespesaOrigemId: registro?.id,
  };

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const getTituloSecaoBaixa = (values) => {
    let titulo = 'Baixa da ';
    if (values?.parcelamentoDespesaOrigemId) {
      titulo += `conta selecionada - Parcela ${values?.parcela}/${values?.numeroParcelas}`;
    } else if (values?.retencaoDespesaOrigemId || values?.retencaoId) {
      titulo += 'retenção selecionada';
    } else {
      titulo += 'conta principal';
    }

    return titulo;
  };

  const valorTotalCategorias = registro?.categorias?.reduce((acc, categoria) => {
    const valorItem = Number(categoria?.valorBruto) || 0;
    return NP.plus(acc, valorItem);
  }, 0);

  return (
    <>
      <CustomExpandedPanel
        title="Dados da despesa"
        expanded={expanded === 'dadosDespesa'}
        onChange={handleChange('dadosDespesa')}
      >
        <Grid container spacing={3}>
          <DadosDespesa values={registro} />
        </Grid>
      </CustomExpandedPanel>
      {registro?.retencoes && (
        <CustomExpandedPanel title="Retenções" expanded={expanded === 'retencao'} onChange={handleChange('retencao')}>
          <DadosRetencoes values={registro} />
        </CustomExpandedPanel>
      )}
      {registro?.anexos && (
        <CustomExpandedPanel
          title="Documentos anexados"
          expanded={expanded === 'anexos'}
          onChange={handleChange('anexos')}
        >
          <AnexosDocumentos values={registro} />
        </CustomExpandedPanel>
      )}
      {(registro?.baixas || _parcela?.baixas) && (
        <CustomExpandedPanel
          title={getTituloSecaoBaixa(registro?.baixas ? registro : _parcela)}
          expanded={expanded === 'baixaDaConta'}
          onChange={handleChange('baixaDaConta')}
        >
          <Grid container spacing={3}>
            <BaixaDaConta values={registro?.baixas ? registro?.baixas : _parcela?.baixas} />
          </Grid>
        </CustomExpandedPanel>
      )}
      <Grid item xs={12} sm={12}>
        {(registro?.baixas?.length > 0 || registro?.contaPagarParcela?.baixas?.length > 0) && (
          <CustomExpandedPanel
            title="Pagamentos realizados"
            expanded={expanded2 === 'pagamentos'}
            onChange={(_, value) => handleExpandedChange('pagamentos', value)}
          >
            <ContasPagarPagamentosRealizados
              baixas={registro?.baixas || registro?.contaPagarParcela?.baixas || undefined}
              showTitle={false}
              showCancelarBaixa={false}
              showParcelas={false}
            />
          </CustomExpandedPanel>
        )}
      </Grid>
      <Grid item xs={12} sm={12}>
        {registro?.aproveitamentoCredito && (
          <CustomExpandedPanel
            title="Aproveitamentos de crédito IBS/CBS"
            expanded={expanded === 'ibsCbs'}
            onChange={handleChange('ibsCbs')}
          >
            <AproveitamentoCredito
              values={registro?.aproveitamentoCredito}
              valorTotalCategorias={valorTotalCategorias}
            />
          </CustomExpandedPanel>
        )}
      </Grid>
      {registro?.historico?.length > 0 && (
        <CustomExpandedPanel
          title="Histórico de alterações"
          expanded={expanded === 'historico'}
          onChange={handleChange('historico')}
        >
          <HistoricoContasPagarVisualizacao historico={registro.historico} />
        </CustomExpandedPanel>
      )}
    </>
  );
};
const ContasPagarVisualizar = ({ semAcoes = false, origemConciliacao }) => {
  const [state, dispatch] = useContasPagar();
  const { registro, visualizar, filtroAvancado, requestParams } = state;

  // Estado para controlar se o registro já foi processado
  const [retencaoProcessada, setRetencaoProcessada] = useState(false);

  const registroRetencao = async () => {
    const response = await contasPagarApi.buscarPorId(registro.retencaoId);

    const retencao = response.data;

    let historico = registro.historico || [];
    try {
      const responseHistorico = await contasPagarApi.buscarHistorico(registro.retencaoId);
      historico = responseHistorico?.data || [];
    } catch (error) {
      // mantém histórico já carregado
    }

    const novoRegistro = {
      ...registro,
      baixas: retencao.baixas,
      situacao: retencao.situacao,
      historico,
    };

    dispatch(ContasPagarAction.atualizarRegistro(novoRegistro));
    setRetencaoProcessada(true);
  };

  useEffect(() => {
    if (registro?.retencaoId && !retencaoProcessada && visualizar) {
      registroRetencao();
    }
    // Efeito reativo apenas ao gatilho listado; incluir as demais dependências alteraria
    // quando o efeito dispara.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [registro]);

  useEffect(() => {
    if (!visualizar) {
      setRetencaoProcessada(false);
    }
  }, [visualizar]);

  const handleCancelar = () => ContasPagarAction.fecharModalCadastro(dispatch);

  const editar = async () => {
    const response = await fechamentoPeriodoApi.buscarUltimoPeriodo('COMPRAS_PAGAMENTO', registro.dataVencimento);
    if (response.data) {
      if (response.data.bloquearAnteriores) {
        if (
          moment(registro.dataVencimento).isSameOrBefore(response.data.periodo) &&
          response.data.funcionalidades.includes('COMPRAS_PAGAMENTO')
        ) {
          ContasPagarAction.fecharModalCadastro(dispatch);
          throw dispatch(
            ContasPagarAction.erro(
              'Não é possível lançar, editar e excluir contas com data de vencimento referente a um período já fechado no sistema.'
            )
          );
        }
      }
    }

    if (registro?.retencaoId) {
      // RNE-113: Quando a despesa selecionada for uma retenção,
      // o sistema deve exibir a aba "Retenções" aberta por padrão.
      ContasPagarAction.selecionarAbaCadastro(dispatch, 1);
    }

    ContasPagarAction.requestEditar(dispatch, [registro?.id], {});
  };

  const baixar = () => {
    const registroParcela = { ...registro?.contaPagarParcela };

    if (Object.keys(registroParcela).length === 0) {
      if (registro?.parcelamentoDespesaOrigemId) {
        registro.valorBruto = registro.valorLiquidoParcela;
        registro.valorLiquido = registro.valorLiquidoParcela;
      } else if (registro?.retencaoId) {
        const retencao = registro.retencoes.find((r) => r.id === registro.retencaoId);
        registro.valorBruto = retencao.valor;
        registro.valorLiquido = retencao.valor;
        registro.id = retencao.id;
      }
      ContasPagarAction.requestBaixa(dispatch, [registro]);
    } else {
      ContasPagarAction.requestBaixa(dispatch, [registroParcela]);
    }
  };

  const cancelarBaixa = async () => {
    ContasPagarAction.cancelarBaixas(dispatch, [registro], requestParams, filtroAvancado);
  };

  // Verificar se a parcela selecionada está baixada
  let parcelaSelecionadaBaixada = false;
  let idParcelaSelecionadaBaixada = '';
  if (registro?.parcelamento?.despesaOrigemId) {
    parcelaSelecionadaBaixada = registro.parcelamento.parcelas[registro.parcela - 1]?.situacao === 'BAIXADA';
    if (parcelaSelecionadaBaixada) {
      idParcelaSelecionadaBaixada = registro.parcelamento.parcelas[registro.parcela - 1]?.id;
    }
  }

  const getIdDespesaBaixada = () => {
    if (registro?.baixa && registro?.retencaoId) {
      return registro?.retencaoId;
    }
    if (parcelaSelecionadaBaixada && idParcelaSelecionadaBaixada.length > 0) {
      return idParcelaSelecionadaBaixada;
    }
    return registro?.id;
  };

  const verificaSituacao = () => {
    if (registro?.situacao === 'BAIXADA' || registro?.situacao === 'EXCLUIDA') {
      return false;
    }

    if (registro?.situacao === 'PARCIALMENTE_BAIXADA' && !registro?.baixas?.some((baixa) => baixa?.id)) {
      return true;
    }

    if (registro?.situacao === 'ABERTA' || registro?.situacao === 'PARCIAL') {
      return true;
    }

    return false;
  };

  const actions = [];
  if (ContasPagarUtil.verificarExibicaoEditarVisualizar(registro) && !semAcoes && permissaoUtils.contaPagar().editar) {
    actions.push({
      label: 'Editar',
      onClick: () => {
        editar();
      },
    });
  }

  if ((!!registro?.baixas || parcelaSelecionadaBaixada) && !semAcoes) {
    actions.push({
      label: 'Emitir recibo',
      onClick: async () => {
        // visualizarRelatorio(getIdDespesaBaixada(), 'conta-pagar/recibo', `titulo=recibos`);
        const response = await relatorioApi().salvarFiltroRecibo([getIdDespesaBaixada()]);
        visualizarRelatorioV2(response.data);
      },
    });
    actions.push({
      label: 'Emitir detalhes',
      onClick: async () => {
        // visualizarRelatorio(getIdDespesaBaixada(), 'conta-pagar/detalhes', `titulo=detalhes`);
        const response = await relatorioApi().salvarFiltroEmitirDetalhesBaixaContaPagar([getIdDespesaBaixada()]);
        visualizarRelatorioV2(response.data);
      },
    });
  }

  if ((registro?.baixas?.length > 0 || registro?.contaPagarParcela?.baixas?.length > 0) && !semAcoes) {
    actions.push({
      label: 'Cancelar baixa',
      onClick: () => {
        cancelarBaixa();
        ContasPagarAction.fecharModalCadastro(dispatch);
      },
    });
  }

  if (verificaSituacao() && !parcelaSelecionadaBaixada && !semAcoes) {
    actions.push({
      label: 'Baixar',
      onClick: () => {
        baixar();
      },
    });
  }

  return (
    <SimpleDialog open={visualizar} onClose={handleCancelar}>
      <SimpleDialogContent
        header={{
          title: 'Lançamento de conta a pagar',
          icon: <FaArrowCircleDown />,
          toolbar: (
            <>
              <CancelButton onClick={handleCancelar}>Fechar</CancelButton>
              {actions?.length && !origemConciliacao ? <GroupButton actions={actions} label="Ações" /> : undefined}
            </>
          ),
        }}
        content={<FormVisualizar registro={registro} />}
        contentStyle={{ padding: 0 }}
      />
    </SimpleDialog>
  );
};

export default ContasPagarVisualizar;
